import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Skeletor } from 'vue-skeletor';
import apolloProvider from '../apollo-client';
import VueSplide from '@splidejs/vue-splide';

createApp(App)
.use(store)
.use(router)
.use(apolloProvider)
.use( VueSplide )
.component(Skeletor.name, Skeletor)
.mount('#app')


